export const UPDATE_DATE = 'UPDATE_DATE';
export const UPDATE_MIN_DATE = 'UPDATE_MIN_DATE';
export const UPDATE_DATE_PERIOD = 'UPDATE_DATE_PERIOD';
export const UPDATE_PERIOD = 'UPDATE_PERIOD';
export const UPDATE_COMPARE_TO = 'UPDATE_COMPARE_TO';
export const TOGGLE = 'TOGGLE';
